<template>
  <div>
    <!--筛选栏-->
    <div class="dateTab">
      <!--时间筛选-->
      <div class="yearList sepyear" style="border: 0px solid #ebebeb">
        <date-picker
          style="width: 114px; border: 1px solid rgb(235, 235, 235)"
          size="small"
          v-model="date_options[0]"
          type="year"
          :picker-options="pickerOptions"
          clearable
        >
        </date-picker>
      </div>
      <div class="yearList sepyear" style="width: 114px; border: 0px solid #ebebeb">
        <date-picker
          style="width: 114px; border: 1px solid rgb(235, 235, 235)"
          size="small"
          v-model="date_options[1]"
          type="year"
          :picker-options="pickerOptions"
          clearable
        >
        </date-picker>
      </div>
      <!-- 省筛选 -->
      <select-single-search
        v-model="conditions.provience"
        :width="80"
        text="省"
        :options="options.provience_options"
        @reset="conditions_init"
        :key="'provience' + component_key"
      />
      <!-- 市筛选 -->
      <select-single-search
        v-model="conditions.city"
        :width="80"
        text="市"
        :options="options.city_options"
        @reset="conditions_init"
        :key="'city' + component_key"
      />
      <!--车企筛选-->
      <select-letter
        v-model="conditions.manufacturer"
        text="车企"
        :options="options.manufacturer_options"
        @reset="conditions_init"
        :key="'manufacturer' + component_key"
      />
      <!--按钮-->
      <div class="selectBut">
        <a @click="query" href="javascript:;" id="btn_query">查询</a>
        <a @click="reset" href="javascript:" class="clear">清空</a>
      </div>

      <!-- 面包屑 -->
      <bread-crumb-map
        v-model="breadcrumb_conditions"
        :options="options"
        @filter="filter"
        @deselect="deselect"
      />

    </div>
    <!--图表-->
    <div class="countChart">
      <div class="charTitle">
        <chart-title :words="title_data" />
      </div>
      <div class="carChart" style="height: 400px">
        <china-map
          :map_name="map_name"
          :text="data_text"
          :projects="volume_data.map"
          styles="width: 480px;height:400px;float:left; position:absolute"
          :is_loading="is_loading"
        />
        <bar
          :axis_name="axis_name"
          :series_name="data_text"
          :projects="volume_data.chart"
          :grid="[{ x: '25%', y: '10%', width: '60%', height: '75%' }]"
          style="width: 480px; height: 400px; float: right; margin-left: 480px"
          :is_loading="is_loading"
        />
      </div>
    </div>
    <!--表格-->
    <div class="detailData">
      <div class="charTitle">
        <div class="title">所选详细数据</div>
        <download
          url="/excel/region"
          :params="{
            startYear: date_options[0].getFullYear(),
            endYear: date_options[1].getFullYear(),
            provienceId: conditions.provience,
            cityId: conditions.city,
            manufacturerId: conditions.manufacturer,
            isCapacity: conditions.is_capacity === 1 ? true : false,
          }"
          :words="title_data"
        />
      </div>
      <div class="detailshow">
        <div class="dtDLeft onelineLeft">
          <div class="dataForm" :style="is_loading ? 'height:416px;' : ''">
            <transition name="loading">
              <loading v-show="is_loading" />
            </transition>
            <transition name="loading">
              <table
                cellpadding="0"
                cellspacing="0"
                border="0"
                width="100%"
                v-show="!is_loading"
              >
                <tbody>
                  <tr class="mainTitle">
                    <th class="nullzone"></th>
                    <th v-show="table_head.city" class="nullzone"></th>
                    <th v-show="table_head.manufacturer" class="nullzone"></th>
                    <th v-show="table_head.manufacturing_site" class="nullzone"></th>
                    <th :colspan="table_head.year_gap">{{ data_text }}</th>
                    <th v-show="table_head.capacity" :colspan="table_head.year_gap">
                      产能利用率
                    </th>
                  </tr>
                  <tr>
                    <th class="nullzone">省</th>
                    <th v-show="table_head.city" class="nullzone">市</th>
                    <th v-show="table_head.manufacturer" class="nullzone">车企</th>
                    <th v-show="table_head.manufacturing_site" class="nullzone">工厂</th>
                    <th v-for="(item, index) in volume_data.times" :key="index">
                      {{ item }}
                    </th>
                    <th
                      v-show="table_head.capacity"
                      v-for="(item, index) in volume_data.times"
                      :key="'capacity' + index"
                    >
                      {{ item }}
                    </th>
                  </tr>
                  <tr v-for="(item, index) in volume_data.result" :key="index">
                    <td>{{ item.provienceName }}</td>
                    <td v-show="table_head.city">{{ item.cityName }}</td>
                    <td v-show="table_head.manufacturer">
                      {{ item.vehicleManufacturer }}
                    </td>
                    <td v-show="table_head.manufacturing_site">
                      {{ item.manufacturingSite }}
                    </td>
                    <td v-for="(volume, index) in item.volumes" :key="'volume' + index">
                      {{ volume | num_format }}
                    </td>
                    <td
                      v-show="table_head.capacity"
                      v-for="(capacity, index) in item.capacities"
                      :key="index"
                    >
                      {{ capacity }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </transition>
          </div>
        </div>
        <div class="dtDRight onelineRight">
          <div class="dateEdit"></div>
        </div>
      </div>
      <pagination
        :page="page"
        @pagehandler="pageHandler"
        v-show="page.total > page.size"
      />
    </div>
    <!--提示-->
    <tips />
  </div>
</template>

<script>
import BreadCrumbMap from "@/components/breadcrumb_map";
import SelectSingleSearch from "@/components/select/select-single-search";
import SelectLetter from "@/components/select/select-letter";
import { DatePicker } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Tips from "@/components/tips";
import Loading from "@/components/loading";
import Pagination from "@/components/pagination";
import Download from "@/components/download";
import Bar from "@/components/echarts/bar-charts";
import ChinaMap from "@/components/echarts/map-charts";
import ChartTitle from "@/components/chart-title";

export default {
  name: "map-production",
  metaInfo() {
    return {
      title: this.meta.title,
      meta: [
        {
          name: "keywords",
          content: this.meta.keywords,
        },
        {
          name: "description",
          content: this.meta.description,
        },
      ],
    };
  },
  components: {
    SelectSingleSearch,
    SelectLetter,
    DatePicker,
    Tips,
    Loading,
    Pagination,
    Download,
    Bar,
    ChinaMap,
    ChartTitle,
    BreadCrumbMap,
  },
  data() {
    return {
      meta: {
        title: "",
        keywords: "",
        description: "",
      },
      date_options: [new Date(), new Date()],
      options: {
        manufacturer_options: [],
        provience_options: [],
        city_options: [],
      },
      breadcrumb_conditions: {},
      conditions: {
        provience: 0,
        city: 0,
        manufacturer: 0,
        is_capacity: 0,
      },
      volume_data: {},
      title_data: [],
      map_name: "china",
      table_head: {
        year_gap: 0,
        city: false,
        manufacturer: false,
        manufacturing_site: false,
        capacity: false,
      },
      page: {
        index: 1,
        size: 10,
        temp_index: 1,
        total: 0,
      },
      pickerOptions: {
        disabledDate(time) {
          var startdate = new Date("2015-12-31").getTime();
          var enddate = new Date("2028-12-31").getTime();
          return !(time.getTime() > startdate && time.getTime() < enddate);
        },
      },
      data_text: "产量",
      axis_name: "车企（辆）",
      is_loading: true,
      component_key: 0,
    };
  },
  watch: {
    $route(new_val) {
      this.is_loading = true;
      this.conditions.data_type = new_val.params.data_type;
      this.conditions.is_capacity =
        this.conditions.data_type === "production"
          ? 0
          : this.conditions.data_type === "capacity"
          ? 1
          : 0;
      if (this.conditions.is_capacity === 1) {
        this.data_text = "产能";
        this.table_head.capacity = true;
        this.meta.title = "乘用车市场产能分布地图-盖亚系统";
        this.meta.keywords = "乘用车市场产能分布地图";
        this.meta.description =
          "乘用车市场产能分布地图：可根据时间选项查询到对应时间范围内的乘用车市场产能分布详细数据。";
      } else {
        this.data_text = "产量";
        this.table_head.capacity = false;
        this.meta.title = "乘用车市场产量分布地图-盖亚系统";
        this.meta.keywords = "乘用车市场产量分布地图";
        this.meta.description =
          "乘用车市场产量分布地图：可根据时间选项查询到对应时间范围内的乘用车市场产量分布详细数据。";
      }
      this.time_init();
    },
  },
  mounted() {
    this.conditions.data_type = this.$route.params.data_type;
    this.conditions.provience =
      this.$route.params.provience === undefined
        ? 0
        : Number(this.$route.params.provience);
    if (this.conditions.provience !== 0)
      this.map_name = this.$store.state.cityArr[2][
        this.$store.state.cityArr[3].findIndex(
          (item) => item === this.conditions.provience.toString()
        )
      ];

    this.conditions.is_capacity =
      this.conditions.data_type === "production"
        ? 0
        : this.conditions.data_type === "capacity"
        ? 1
        : 0;
    if (this.conditions.is_capacity === 1) {
      this.data_text = "产能";
      this.table_head.capacity = true;
      this.meta.title = "乘用车市场产能分布地图-盖亚系统";
      this.meta.keywords = "乘用车市场产能分布地图";
      this.meta.description =
        "乘用车市场产能分布地图：可根据时间选项查询到对应时间范围内的乘用车市场产能分布详细数据。";
    } else {
      this.data_text = "产量";
      this.table_head.capacity = false;
      this.meta.title = "乘用车市场产量分布地图-盖亚系统";
      this.meta.keywords = "乘用车市场产量分布地图";
      this.meta.description =
        "乘用车市场产量分布地图：可根据时间选项查询到对应时间范围内的乘用车市场产量分布详细数据。";
    }
    this.conditions_init();
    this.time_init();
  },
  methods: {
    time_init() {
      let _this = this;
      this.$http({
        url: "/region/init",
        method: "get",
        crossdomain: true,
        params: {
          isCapacity: _this.conditions.is_capacity === 1 ? true : false,
        },
      })
        .then(function (res) {
          _this.date_options = [
            new Date(res.data.start_year.toString() + "/1/1"),
            new Date(res.data.end_year.toString() + "/1/1"),
          ];
          _this.filter();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    conditions_init() {
      let _this = this;
      this.$http({
        url: "/region/condition",
        method: "get",
        crossdomain: true,
        params: {
          provienceId: _this.conditions.provience,
          cityId: _this.conditions.city,
          manufacturerId: _this.conditions.manufacturer,
        },
      })
        .then(function (res) {
          _this.options.provience_options = res.data.proviences.sort(
            // (a, b) =>
            // a.provienceName.localeCompare(b.provienceName, "zh")
          );
          _this.options.city_options = res.data.cities.sort(
            // (a, b) =>
            // a.cityName.localeCompare(b.cityName, "zh")
          );
          _this.options.manufacturer_options = res.data.manufacturers;
          _this.time_init();
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    query() {
      this.page.temp_index = 1;
      this.is_loading = true;
      this.filter();
    },
    reset() {
      this.is_loading = true;
      this.conditions.provience = this.conditions.city = this.conditions.manufacturer = 0;
      this.conditions_init();
      this.component_key += 1;
      this.filter();
      this.table_head.city = this.table_head.manufacturer = this.table_head.manufacturing_site = false;
    },
    filter() {
      let _this = this;
      this.$http({
        url: "/region/filter",
        method: "get",
        crossdomain: true,
        params: {
          startYear: _this.date_options[0].getFullYear(),
          endYear: _this.date_options[1].getFullYear(),
          provienceId: _this.conditions.provience,
          cityId: _this.conditions.city,
          manufacturerId: _this.conditions.manufacturer,
          isCapacity: _this.conditions.is_capacity,
          pageIndex: _this.page.temp_index,
          pageSize: _this.page.size,
        },
      })
        .then(function (res) {
          _this.volume_data = res.data;
          _this.table_head.year_gap =
            _this.date_options[1].getFullYear() - _this.date_options[0].getFullYear() + 1;
          _this.page.total = res.data.allCount;
          _this.page.index = _this.page.temp_index;
          let map_provience = _this.conditions.provience;
          if (map_provience === 0 && _this.conditions.city !== 0) {
            map_provience = _this.options.city_options.find(
              (item) => item.cityId === _this.conditions.city
            ).provienceId;
          }
          _this.map_name =
            _this.$store.state.cityArr[2][
              _this.$store.state.cityArr[3].findIndex(
                (item) => item === map_provience.toString()
              )
            ];
          if (
            _this.conditions.provience !== 0 ||
            _this.conditions.city !== 0 ||
            _this.conditions.manufacturer !== 0
          ) {
            _this.table_head.city = true;
            _this.table_head.manufacturer = true;
          }
          if (_this.conditions.manufacturer !== 0) {
            _this.table_head.manufacturing_site = true;
          }
          _this.axis_name = "车企（辆）";
          if (_this.conditions.manufacturer !== 0) {
            _this.axis_name = "工厂（辆）";
          } else if (_this.conditions.provience === 0 && _this.conditions.city === 0) {
            _this.axis_name = "省份（辆）";
          }
          _this.title();
          _this.breadcrumb_conditions = JSON.parse(JSON.stringify(_this.conditions));
          _this.is_loading = false;
        })
        .catch(function (error) {
          _this.is_loading = false;
          if (error.response == undefined) {
            return false;
          }
          switch (error.response.status) {
            case 403:
              _this.page.index = _this.page.temp_index = 1;
              _this.time_init();
              _this.conditions.provience = _this.conditions.city = _this.conditions.manufacturer = 0;
              _this.conditions_init();
              _this.table_head.city = _this.table_head.manufacturer = _this.table_head.manufacturing_site = false;
              break;
          }
        });
    },
    filter_table() {
      this.filter();
    },
    title() {
      let _this = this;
      this.title_data = [];
      if (this.date_options[0].getFullYear() === this.date_options[1].getFullYear()) {
        this.title_data.push(_this.date_options[0].getFullYear());
      } else {
        this.title_data.push(
          _this.date_options[0].getFullYear() + "至" + _this.date_options[1].getFullYear()
        );
      }
      this.title_data.push(
        _this.conditions.provience !== 0
          ? _this.options.provience_options.filter(
              (t) => t.provienceId === _this.conditions.provience
            )[0].provienceName
          : ""
      );
      if (
        this.title_data.indexOf(
          _this.conditions.city !== 0
            ? _this.options.city_options.filter((t) => t.cityId === _this.conditions.city)[0]
                .cityName
            : ""
        ) === -1
      )
        this.title_data.push(
          _this.conditions.city !== 0
            ? _this.options.city_options.filter((t) => t.cityId === _this.conditions.city)[0]
                .cityName
            : ""
        );
      this.title_data.push("乘用车市场");
      this.title_data.push(
        _this.conditions.manufacturer !== 0
          ? _this.options.manufacturer_options.filter(
              (t) => t.manufacturerId === _this.conditions.manufacturer
            )[0].vehicleManufacturer
          : ""
      );
      this.title_data.push(_this.data_text);
      this.title_data.push("分布地图");
    },
    pageHandler: function (page) {
      this.page.temp_index = page;
      this.filter_table();
    },
    deselect(condition_type) {
      switch (condition_type) {
        case "provience":
          this.conditions.provience = 0;
          break;
        case "city":
          this.conditions.city = 0;
          break;
        case "manufacturer":
        this.conditions.manufacturer = 0;
          // this.conditions.manufacturer.splice(
          //   this.conditions.manufacturer.indexOf(choiced_value),
          //   1
          // );
          break;
      }
    },
  },
};
</script>
